import {
    AbstractStoreRoot,
    registerStore,
    StoreRoot,
    StoreRootEventDetailMap
  } from '@genesislcap/foundation-store';
  import { CustomEventMap } from '@genesislcap/foundation-events';
import { PbiStore } from './pbi-store';

  export type RootStoreEvents = StoreRootEventDetailMap;

  declare global {
    interface HTMLElementEventMap extends CustomEventMap<RootStoreEvents> {}
  }

  type RootStoreInternal = {};

  export interface RootStore extends StoreRoot {}

  class RootStoreImpl
    extends AbstractStoreRoot<RootStore, RootStoreEvents, RootStoreInternal>
    implements RootStore
  {
    constructor(
      @PbiStore readonly pbiStore: PbiStore
    ) {
      super(
        pbiStore
      );
    }
  }

  export const RootStore = registerStore(RootStoreImpl, 'RootStore');
